import React from 'react';
import { motion } from 'framer-motion';
import { Shield, MapPin, CheckCircle, Clock } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-301" data-mp="eilfb8ex51em">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-302" data-mp="4mrtszj81xkp">
        <img src="https://cdn.magicpatterns.com/uploads/n9WnN7tSJs3RykszzTvQTA/Banner_JetForce.png" alt="Commercial aircraft on runway" className="w-full h-full object-cover object-center" data-id="element-303" data-mp="4jvxffn0vgyd" />
        <div className="absolute inset-0 bg-navy/35 mix-blend-multiply" data-id="element-304" data-mp="saruar6c52ch"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" data-id="element-305" data-mp="nc89iu3h9wlp"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex flex-col items-center text-center mt-10 sm:mt-0" data-id="element-306" data-mp="3d1a4l90jrr80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-sm text-slate-200 mb-8" data-id="element-307" data-mp="381nwfdzkt162">
          <span className="w-2 h-2 rounded-full bg-gold animate-pulse mr-2" data-id="element-308" data-mp="3e84rho25dizu"></span>
          Nationwide Coverage · AOG Support · 24/7 Dispatch
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-tight tracking-tight mb-4 uppercase" data-id="element-309" data-mp="3599ik47pxusu">
          We Move What <br className="hidden sm:block" data-id="element-310" data-mp="2ljgyt7f2jrc9" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-311" data-mp="2lmlcqwic61g4">
            Keeps You Flying.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl sm:text-2xl text-gold font-medium mb-6 tracking-wide" data-id="element-312" data-mp="n9qkbeikj2a2">
          Safe Transport. Secure Handling. Nationwide Coverage.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-3xl text-base sm:text-lg text-slate-300 mb-10 leading-relaxed" data-id="element-313" data-mp="112pwp7n20gde">
          JetForce Aerospace provides specialized aviation transportation and
          maintenance services for airlines, MROs, repair stations, OEMs and
          operators across the United States.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-4 mb-16 w-full sm:w-auto" data-id="element-314" data-mp="218tprvkjzaev">
          <a href="#contact" className="w-full sm:w-auto bg-gold hover:bg-gold-light text-navy font-bold py-4 px-8 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 text-center text-lg" data-id="element-315" data-mp="2kxudxhjlvg56">
            Request a Quote
          </a>
          <a href="#services" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-3.5 px-8 rounded-full transition-all text-center text-lg backdrop-blur-sm" data-id="element-316" data-mp="uo0uu4cjcyr6">
            Explore Our Services
          </a>
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 w-full max-w-4xl border-t border-white/10 pt-8" data-id="element-317" data-mp="e9a765fb70lo">
          {[{
          icon: Shield,
          text: 'Experienced Team'
        }, {
          icon: MapPin,
          text: 'Nationwide Service'
        }, {
          icon: CheckCircle,
          text: 'Fully Insured'
        }, {
          icon: Clock,
          text: 'On Time. Every Time.'
        }].map((badge, idx) => <div key={idx} className="flex flex-col items-center justify-center text-center group" data-id="element-318" data-mp="19hm7xy8946if" data-mpi={idx}>
              <div className="w-12 h-12 rounded-full bg-navy-light/80 border border-gold/30 flex items-center justify-center mb-3 group-hover:border-gold transition-colors shadow-lg" data-id="element-319" data-mp="1ebgpow4aqbev">
                <badge.icon className="w-6 h-6 text-gold" data-id="element-320" data-mp="14ju5wbdw740i" />
              </div>
              <span className="text-sm font-medium text-slate-300 font-heading tracking-wider uppercase" data-id="element-321" data-mp="1sagec3rt6qb1">
                {badge.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}